import ImagePreview from 'components/common/image-preview'
import { StatusComponent } from 'components/common/others'
import { AssetImage } from 'components/WorkOrders/onboarding/utils'
import enums from 'Constants/enums'
import { get, isEmpty } from 'lodash'
import React, { useState } from 'react'

const SiteDetails = ({ siteDetails }) => {
  const [isPreviewOpen, setPreview] = useState(false)

  const getStatus = status => {
    const statusLabel = enums.USER_STATUS_CHIPS.find(d => d.value === status)
    return statusLabel ? <StatusComponent color={statusLabel?.color} label={statusLabel?.label} size='small' /> : 'N/A'
  }

  const getContacts = site => {
    return <div>{get(site, 'sitecontactData.sitecontactName', 'N/A') !== 'N/A' ? <StatusComponent color='#848484' label={get(site, 'sitecontactData.sitecontactName')} size='medium' /> : 'N/A'}</div>
  }

  const getAddress = siteDetails => {
    const fields = [get(siteDetails, 'customerAddress', ''), get(siteDetails, 'customerAddress1', ''), get(siteDetails, 'city', ''), get(siteDetails, 'state', ''), get(siteDetails, 'zip', '')]
    const address = fields.filter(Boolean).join(', ')
    return <div>{address || 'N/A'}</div>
  }

  const parse = key => get(siteDetails, [key], 'N/A') || 'N/A'

  const handleManagers = data => {
    return !isEmpty(data)
      ? data?.map(d => (
          <div className='mr-1 mb-2'>
            <StatusComponent color='#848484' label={d.name} size='small' />
          </div>
        ))
      : 'N/A'
  }

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '28% 72%', rowGap: '24px' }}>
        <div className='text-bold'>Site Name</div>
        <div>{parse('siteName')}</div>
        <div className='text-bold'>Site Code</div>
        <div>{parse('siteCode')}</div>
        <div className='text-bold'>Status</div>
        <div>{getStatus(siteDetails.status)}</div>
        <div className='text-bold'>Project Managers</div>
        <div className='d-flex flex-wrap'>{handleManagers(siteDetails.siteProjectmanagerList)}</div>
        <div className='text-bold'>Customer</div>
        <div>{parse('customer')}</div>
        <div className='text-bold'>Customer Address</div>
        <div>{getAddress(siteDetails)}</div>
        <div className='text-bold'>Facility Contacts</div>
        <div>{getContacts(siteDetails)}</div>
        <div className='text-bold'>Is Allowed to Add Asset Class?</div>
        <div>{siteDetails.isAddAssetClassEnabled === true ? 'Yes' : 'No'}</div>
        <div className='text-bold'>Site Photo</div>
        {siteDetails.profileImage != null && <AssetImage readOnly url={siteDetails.profileImage} onClick={() => setPreview(true)} />}
      </div>
      {isPreviewOpen && <ImagePreview open={isPreviewOpen} onClose={() => setPreview(false)} imageIndex={0} images={[{ imageFileNameUrl: siteDetails.profileImage }]} urlKey='imageFileNameUrl' hideRotateButton={true} />}
    </div>
  )
}

export default SiteDetails
